const indexItems = [
  { id: 1, icon: 'ri-heart-line', label: '恋爱漫画', count: '2,340部', color: 'bg-accent-100 text-accent-700' },
  { id: 2, icon: 'ri-magic-line', label: '奇幻漫画', count: '1,892部', color: 'bg-primary-100 text-primary-700' },
  { id: 3, icon: 'ri-sword-line', label: '动作漫画', count: '1,567部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, icon: 'ri-search-eye-line', label: '悬疑漫画', count: '983部', color: 'bg-accent-100 text-accent-700' },
  { id: 5, icon: 'ri-emotion-laugh-line', label: '搞笑漫画', count: '1,245部', color: 'bg-primary-100 text-primary-700' },
  { id: 6, icon: 'ri-building-line', label: '校园漫画', count: '1,678部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, icon: 'ri-hourglass-line', label: '穿越漫画', count: '1,102部', color: 'bg-accent-100 text-accent-700' },
  { id: 8, icon: 'ri-store-line', label: '都市漫画', count: '890部', color: 'bg-primary-100 text-primary-700' },
  { id: 9, icon: 'ri-landscape-line', label: '古风漫画', count: '756部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            漫画分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            按类型快速浏览，找到你最喜欢的韩漫品类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} transition-transform group-hover:scale-110 duration-200`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="text-center">
                <p className="font-medium text-sm text-foreground-900 whitespace-nowrap">{item.label}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}